import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-stretch bg-[#16205A]">
      <div
        className="hidden lg:block lg:w-1/2 bg-cover bg-center relative"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1530863506128-dc9eb5c3e0fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBjb25jcmV0ZSUyMHN0ZWVsJTIwcmViYXJ8ZW58MHx8fHwxNzgzNTg0MTA1fDA&ixlib=rb-4.1.0&q=85')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-[#16205A] via-[#16205A]/70 to-[#16205A]/30" />
        <div className="absolute bottom-0 left-0 p-12 text-white">
          <p className="font-mono text-xs tracking-[0.3em] mb-3 text-[#F49B1C]">CONSTRUCTION IRON · REBAR</p>
          <h2 className="font-heading font-black text-5xl leading-[0.95]">
            BUILT<br />ON STEEL.
          </h2>
          <p className="text-slate-300 mt-4 max-w-sm text-sm">
            One roof for customers, balances, jobs and follow-ups.
          </p>
        </div>
      </div>

      <div className="w-full lg:w-1/2 flex items-center justify-center p-6 bg-[#F4F6FB]">
        <div className="w-full max-w-md fade-up">
          <div className="flex flex-col items-center mb-8">
            <img src="/logo.png" alt="Betonwapening Veeris 2.0" className="w-28 h-28 object-contain" />
          </div>

          <div className="card-soft p-8">
            <h2 className="font-heading font-extrabold text-3xl mb-1 text-[#16205A]">Welcome back</h2>
            <p className="text-sm text-slate-500 mb-6">Sign in to your control room.</p>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="font-semibold text-xs uppercase tracking-wide text-slate-500 block mb-1.5">Email</label>
                <input
                  data-testid="login-email-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#F49B1C]/60 focus:border-[#F49B1C]"
                  placeholder="veeris@betonwapening.com"
                />
              </div>
              <div>
                <label className="font-semibold text-xs uppercase tracking-wide text-slate-500 block mb-1.5">Password</label>
                <input
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="w-full border border-slate-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#F49B1C]/60 focus:border-[#F49B1C]"
                  placeholder="••••••••"
                />
              </div>
              {error && (
                <div data-testid="login-error" className="rounded-lg border border-red-200 bg-red-50 text-red-600 text-sm px-3 py-2.5 font-medium">
                  {error}
                </div>
              )}
              <button
                data-testid="login-submit-button"
                type="submit"
                disabled={loading}
                className="w-full bg-[#F49B1C] hover:bg-[#E0890F] text-white font-heading font-bold text-base py-3 rounded-lg shadow-sm shadow-orange-500/30 active:scale-[0.99] transition-all flex items-center justify-center gap-2 disabled:opacity-60"
              >
                {loading ? "Signing in…" : "Sign In"} {!loading && <ArrowRight size={18} weight="bold" />}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
